<template>
  <v-combobox
    :autocomplete="autocomplete"
    aria-autocomplete="none"
    v-bind="$attrs"
    item-text="libelle"
    v-model="commune"
    :loading="loading"
    :search-input.sync="recherche"
    @update:search-input="updateInputValue"
    @change="selectItem"
    :items="communes"
    return-object
    :data-testid="dataTestid"
  />
</template>

<script>
import _ from "lodash";
import { communeService } from "@/services";
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    codePostal: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      loading: false,
      items: [],
      recherche: null,
      commune: null,
      libelle: null,
      autocomplete: Math.random().toString(36).slice(2), // Génère une chaîne aléatoire pour bloquer l'autocomplete des navigateurs
    };
  },

  mounted() {
    this.syncCommune();
    this.debouncedQuery = _.debounce(this.query.bind(this), 250);
  },

  methods: {
    syncCommune() {
      if (this.value) {
        this.libelle = this.value;
        this.commune = { id: -1, libelle: this.value };
      } else {
        this.libelle = null;
        this.commune = null;
        this.items = [];
      }
    },
    query(recherche, codePostal) {
      this.loading = true;
      communeService
        .autocompleteEnum(recherche, { codePostal })
        .then(items => {
          this.items = items;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateInputValue(value) {
      this.libelle = value;
      if(value) {
        this.commune = { id: -1, libelle: value };
      }
    },
    selectItem(value) {
      if (value?.libelle) {
        this.libelle = value.libelle;
          if(value?.codePostaux?.length ===1 ) {
          this.$emit("codePostal", value?.codePostaux);
        }
      }
    },
    demarreRecherche() {
     this.debouncedQuery(this.recherche, this.codePostal);
    },
  },

  watch: {
    recherche() {
      this.demarreRecherche();
    },
    codePostal() {
      this.demarreRecherche();
    },
    value() {
      this.syncCommune();
    },
    libelle() {
      if (this.libelle !== this.value) {
        this.$emit("input", this.libelle, this.codePostal);
      }
    },
  },

  computed: {
    communes() {
      const entete = {
        header: "Sélectionner une valeur, ou saisissez une valeur autre",
      };
      return [entete, ...this.items];
    },
  },
};
</script>
